import { ItemTypeEnum } from '@share/common-types';

import CondoImage from '@assets/images/certificates/condo.png';
import CruiseImage from '@assets/images/certificates/cruise.png';
import HotelImage from '@assets/images/certificates/hotel.png';

// Fallback photos by type, the same assets the certificates catalog uses.
const TYPE_IMAGES: Record<ItemTypeEnum, string> = {
  [ItemTypeEnum.Hotel]: HotelImage,
  [ItemTypeEnum.Condo]: CondoImage,
  [ItemTypeEnum.Cruise]: CruiseImage,
};

/** The certificate's own image, else the photo for its first item type. */
export const getCertificateImage = (
  imageUrl: string | null | undefined,
  firstType: ItemTypeEnum | undefined,
  imageFailed: boolean,
): string => (imageUrl && !imageFailed ? imageUrl : TYPE_IMAGES[firstType as ItemTypeEnum] || HotelImage);
